import { withdrawReferralBonusPayoutUrl } from "../../../api/endpoints";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
import { setUser } from "../../../slice/webStoreUserSlice";
import { NIGERIAN_BANKS } from "../../payouts/Banktransfer";
import "./withdrawFunds.css";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const tk = /* "RkB33GgoSCB1ts3yYiktSyc8oQzero4iG5MgYbym" */ "NUBAN-BZNWFBUV2006";
const WithdrawFunds = ({ referralData, currency }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [bankCode, setBankCode] = useState(""); //selected bank code
  const [accountNumber, setAccountNumber] = useState("");
  const [availableBalance, setAvailableBalance] = useState(referralData.pendingPayouts);
  const [isFormValid, setIsFormValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [accountName, setAccountName] = useState("");
  const [bankName, setBankName] = useState("");
  const [isBankAndAccountNumberValid, setIsBankAndAccountNumberValid] = useState(false);

  const [isValidating, setIsValidating] = useState(false);
  const minimumWithdrawal = 30000;
  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();

  useEffect(() => {
    if (availableBalance <= minimumWithdrawal) {
      setErrorMessage(`Withdrawal amount must be at least ${currency}${minimumWithdrawal.toLocaleString()}.`);
      return;
    } else {
      setErrorMessage("");
    }
    if (availableBalance >= minimumWithdrawal) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [availableBalance, bankCode, accountNumber]);

  //withdrawal function

  const confirmWithdrawal = async () => {
    if (errorMessage) {
      uiAlert(errorMessage, "error");
      return;
    }

    // check if account name is set
    if (!accountName) {
      uiAlert("Please validate your account number before proceeding.", "error");
      return;
    }

    // check if withdraw amount is more than available balance
    if (!isFormValid) {
      uiAlert("You can not proceed. Your available balance is lower than the withdrawal amount.", "error");
      return;
    }

    const withdrawUrl = withdrawReferralBonusPayoutUrl;
    try {
      let payLoad = {
        withdrawAmount: availableBalance,
        bankCode,
        accountNumber,
        accountName,
        bankName,
      };

      let response = await fetch(withdrawUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
        body: JSON.stringify(payLoad),
      });

      if (!response.ok) {
        throw new Error("Failed to submit withdrawal request");
      }
      let { user } = await response.json();
      console.log(user, "updated user after withdrawal request");
      dispatch(setUser(user));
      uiAlert("Withdrawal request submitted successfully. It may take 4-7 business days to process.", "success");
    } catch (error) {
      uiAlert("An error occurred while submitting your withdrawal request. Please try again later. or contact support.", "error");
      console.log(error);
    } finally {
      setIsModalOpen(false);
    }
  };

  const openWithdrawModal = () => {
    // check if user has pending withdrawals

    if (user.madeAWithdrawalRequest) {
      uiAlert("You have a pending withdrawal request. Please wait for it to be processed before making another request.");
      return;
    }
    setIsModalOpen(true);
  };

  const validateAccountNumber = async () => {
    setIsValidating(true);
    let endpoint = `https://app.nuban.com.ng/api/${tk} ?bank_code=${bankCode}&acc_no=${accountNumber}`;
    try {
      console.log(endpoint);
      let response = await fetch(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tk,
        },
      });

      let data = await response.json();
      console.log(data);
      if (data.error) {
        uiAlert("Invalid account number", "error");

        setIsValidating(false);
      } else {
        if (data[0].account_name) {
          console.log(data);
          setIsValidating(false);
          setAccountName(data[0].account_name);
          setBankName(data[0].bank_name);

          return true;
        } else {
          console.log(data);
          uiAlert("Invalid account number", "error");

          setIsValidating(false);
        }
      }
    } catch (error) {
      console.log(error);
      setIsValidating(false);
      return false;
    }
  };

  const unWantedInputs = ["e", "E", "+", "-", "e+", "E+", "e-", "E-", "+-", "-+"];
  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <>
      <div class='wf-storelense-main-card-2k9x'>
        <div class='wf-storelense-content-flex-8h3p'>
          <div class='wf-storelense-balance-wrapper-7m2q'>
            <div class='wf-storelense-icon-box-5n8r'>💰</div>
            <div class='wf-storelense-balance-info-4p7t'>
              <div class='wf-storelense-label-text-9k1s'>Available Balance</div>
              <div class='wf-storelense-amount-display-6w4m'>{currency + availableBalance.toLocaleString()}</div>
              <div class='wf-storelense-meta-container-3r9v'>
                {/* <span class='wf-storelense-pending-text-8q2n'>$50.00 pending</span> */}
                <span class='wf-storelense-divider-dot-5h7k'>•</span>
                <span class='wf-storelense-total-text-2m6p'>{currency + referralData.totalEarnings.toLocaleString()} total earned</span>
              </div>
            </div>
          </div>

          <div class='wf-storelense-actions-column-7j3t'>
            <button onClick={() => openWithdrawModal()} class='wf-storelense-withdraw-button-9k5q'>
              <span>💸</span>
              <span>Withdraw Funds</span>
            </button>
            <div class='wf-storelense-info-badge-4n8w'>
              <span>ℹ️</span>
              <span>Minimum withdrawal: {currency + minimumWithdrawal.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      {isModalOpen && (
        <div onClick={() => setIsModalOpen(false)} class='wf-storelense-modal-overlay-6m2x' id='withdrawModalOverlay'>
          <div onClick={(e) => e.stopPropagation()} class='wf-storelense-modal-container-3h9k'>
            <div class='wf-storelense-modal-header-5n3p'>
              <h3 class='wf-storelense-modal-title-9q8t'>Withdraw Funds</h3>
              <button class='wf-storelense-close-button-4w7m' onClick={() => setIsModalOpen(false)}>
                ×
              </button>
            </div>

            <div class='wf-storelense-modal-body-8j5r'>
              <div class='wf-storelense-balance-display-2k6n'>
                <span class='wf-storelense-balance-label-3m9p'>Available Balance</span>
                <span class='wf-storelense-balance-value-7h4q'>{currency + availableBalance.toLocaleString()}</span>
              </div>

              <div class='wf-storelense-form-group-5p2k'>
                <label class='wf-storelense-form-label-8n6t'>Withdrawal Amount ({currency}) </label>
                <input
                  value={availableBalance.toLocaleString()}
                  key={isMobile ? "mobile" : "desktop"}
                  type={isMobile}
                  readOnly
                  class='wf-storelense-input-field-4q9m'
                  id='withdrawAmountInput'
                  placeholder='Enter amount'
                />
                <div class='wf-storelense-hint-text-6k8p'>
                  <span>💡</span>
                  <span>Minimum withdrawal amount is {currency + minimumWithdrawal}</span>
                </div>
              </div>

              <div class='wf-storelense-form-group-5p2k'>
                <label class='wf-storelense-form-label-8n6t'>Bank transfer</label>
                <select value={bankCode} onChange={(e) => setBankCode(e.target.value)} class='wf-storelense-select-field-7w3n' id='paymentMethodSelect'>
                  <option value='' disabled selected hidden>
                    Select bank
                  </option>
                  {NIGERIAN_BANKS.map((bank, index) => (
                    <option key={index} value={bank.code}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>

              <div class='wf-storelense-form-group-5p2k'>
                <label class='wf-storelense-form-label-8n6t'>Account number</label>
                <div className='actNoValDiv'>
                  <input
                    key={isMobile ? "mobile" : "desktop"}
                    type={isMobile ? "text" : "number"}
                    onKeyDown={(e) => {
                      // if enter is pressed, validate account number
                      if (e.key === "Enter") {
                        validateAccountNumber();
                      }
                    }}
                    inputMode='numeric' // shows numeric keyboard on mobile
                    pattern={isMobile ? "[0-9]*" : undefined}
                    onBeforeInput={isMobile ? allowDigits : undefined}
                    onChange={(e) => {
                      const raw = e.target.value;
                      if (unWantedInputs.includes(e.nativeEvent.data)) return;

                      if (raw === "") {
                        setAccountNumber("");
                        return;
                      }

                      setAccountNumber(raw);
                    }}
                    class='wf-storelense-input-field-4q9m'
                    id='accountDetailsInput'
                    placeholder='Enter account number'
                  />
                  <button disabled={isValidating || !bankCode || !accountNumber} className='validateActBtn' onClick={validateAccountNumber}>
                    {isValidating ? "Validating..." : "Validate"}
                  </button>
                </div>
                {accountName && (
                  <div class='wf-storelense-hint-text-6k8p'>
                    <span>✅</span>
                    <span>Account Name: {accountName}</span>
                  </div>
                )}
                <div class='wf-storelense-hint-text-6k8p'>
                  <span>🔒</span>
                  <span>Your information is encrypted and secure</span>
                </div>
              </div>
            </div>

            <div class='wf-storelense-modal-footer-9m2r'>
              <button class='wf-storelense-action-button-3h7k wf-storelense-cancel-btn-5q4n' onClick={() => setIsModalOpen(false)}>
                Cancel
              </button>
              <button class='wf-storelense-action-button-3h7k wf-storelense-submit-btn-8w6p' onClick={confirmWithdrawal}>
                Confirm Withdrawal
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WithdrawFunds;
